module.exports = "<div class=ui-grid-cell-contents> <a ng-if=\"row.entity.userRoleId === 4\" class=\"text-xs m-r-md\" ui-sref=\"generalSettings.editCommittee({committeeId: row.entity.comiteeId})\"> <i class=\"icon mdi-editor-border-color i-16 dark-icon m-r-xs\"></i> Editar </a> <a class=\"text-xs m-r-md\" ng-click=grid.appScope.usrVM.confirmDisableComite(row.entity) has-permission=crear-comite-edit> <i class=\"icon mdi-action-delete i-16 dark-icon m-r-xs\"></i> Eliminar </a> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/generalSettings/users/list/comiteActionsCell.html
// module id = 272
// module chunks = 0